import { Address } from 'src/app/models/address.model';
import { FocusSettings } from 'src/app/models/app-settings.model';
import { CompanyInfo } from 'src/app/models/company-info.model';
import { SoilInfo } from 'src/app/models/soil-info.model';

import { PostCustomerSettingsRequest } from '../request-models/customer-settings.model';

export const mapCustomerSettingsRequest = ([
  address,
  companyInfo,
  soilInfo,
  focusSettings,
]: [
  Address | undefined,
  CompanyInfo | undefined,
  SoilInfo | undefined,
  FocusSettings | undefined,
]): PostCustomerSettingsRequest | undefined => {
  return address === undefined ||
    companyInfo === undefined ||
    soilInfo === undefined ||
    focusSettings === undefined
    ? undefined
    : {
        postalCode: address.postalCode,
        houseNumber: address.houseNumber,
        numberOfCows: companyInfo.amountOfCows,
        soilType: companyInfo.soilType,
        grassHectare: soilInfo.grassHectares,
        maizeHectare: soilInfo.cornHectares,
        focuses: focusSettings.focusTypes,
        otherFocus: focusSettings.otherFocus,
      };
};
